import { render, staticRenderFns } from "./ComunicatiStampa.vue?vue&type=template&id=5745eced"
import script from "./ComunicatiStampa.vue?vue&type=script&lang=js"
export * from "./ComunicatiStampa.vue?vue&type=script&lang=js"
import style0 from "./ComunicatiStampa.vue?vue&type=style&index=0&id=5745eced&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports